<template>
  <div>
   <Header></Header>
   <main class="APP-contents">
      <div class="question-wrapper">
         <div class="question relative overflow-hidden">
            <div class="margin-vert-40px medium-margin-vert-100px">
               <div class="margin-vert-60px large-margin-vert-80px">
                  <div class="post">
                     <div class="container">

                        
                        <div v-for="(question, i) in questions" :key="i">
                          <div v-show="i === current">
                            <div class="post__num">
                              <p class="post__num-text margin-vert-0px">Q{{questions[i].number}}</p>
                            </div>
                            <div class="post__question">
                              <p class="post__question-text margin-vert-0px"><span v-html="questions[i].text"></span></p>
                            </div>
                          </div>
                        </div>
                        

                        <div class="post-answer">
                           <div class="medium-row-gutter-40px">
                              <div class="medium-col-6of12">
                                 <div class="margin-vert-20px medium-margin-vert-0px">
                                    <button class="post-answer-button expanded margin-vert-0px" @click="answer(true, $event);">はい</button>
                                 </div>
                              </div>
                              <div class="medium-col-6of12">
                                 <div class="margin-vert-20px medium-margin-vert-0px">
                                    <button class="post-answer-button expanded margin-vert-0px" @click="answer(false, $event)">いいえ</button>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="margin-vert-20px large-margin-vert-60px">
                  <div class="container">
                     <div class="medium-display-flex flex-direction-row-reverse">
                        <div class="flex-grow text-center medium-display-flex align-items-center justify-content-center">
                           <ul class="bullets display-inline-block">
                              <li v-for="(question, i) in questions" :key="i" class="bullet" v-bind:class="{ current: current === i }"><span>{{question.number}}</span></li>
                           </ul>
                        </div>
                        <div class="margin-vert-20px medium-margin-vert-0px">
                           <div class="text-center">
                              <button v-on:click="reset" class="question-back-button">
                                 最初から診断する
                                 <span class="question-back-button-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                                       <title>arrow left</title>
                                       <polyline points="177.25 226.5 78.75 128 177.25 29.5" fill="none" stroke="#000" stroke-miterlimit="10" stroke-width="30"/>
                                    </svg>
                                 </span>
                              </button>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </main>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import personalityService from '@/service/personality';

export default {
  name: "question",
  components: {
    Header
  },
  data(){
     return {
        publicPath: process.env.BASE_URL,
        current: 0,
        point: {
          CP: 0,
          NP: 0,
          A: 0,
          FC: 0,
          AC: 0
        },
        questions: [
         {  
            number: "1",
            type: "CP",
            text: "自分は怒りっぽい性格だ",
         },
         {
            number: "2",
            type: "CP",
            text: "お金があっても幸せに<br>なれると限らない",
         },
         {
            number: "3",
            type: "NP",
            text: "頼み事をされると基本、断れない",
         },
         {
            number: "4",
            type: "NP",
            text: "自分で料理することが好き",
         },
         {
            number: "5",
            type: "A",
            text: "仕事で大事なのは<br>「情熱」よりも「ロジック」だ",
         },
         {
            number: "6",
            type: "A",
            text: "整理整頓が得意な方だ",
         },
         {
            number: "7",
            type: "FC",
            text: "人に好かれる方だ",
         },
         {
            number: "8",
            type: "FC",
            text: "新しいことにチャレンジするのが<br class=\"display-none medium-display-inline\">好きだ",
         },
         {
            type: "AC",
            text: "やりたくないことは<br>後回しにするほうだ",
            number: "9",
         },
         {
            number: "10",
            type: "AC",
            text: "自分は寂しがり屋だ",
         },
        ]
     }
  },
  methods: {
     answer(bool, event){
        const question = this.$data.questions[this.$data.current];
        const type = question.type;
        
        if( bool === true ){
          switch(type){
            case "CP":
              this.$data.point.CP += 1;
              break;
            case "NP":
              this.$data.point.NP += 1;
              break;
            case "A":
              this.$data.point.A += 1;
              break;
            case "FC":
              this.$data.point.FC += 1;
              break;
            case "AC":
              this.$data.point.AC += 1;
              break;
          }
        }
        const point = String(this.$data.point.CP) + String(this.$data.point.NP) + String(this.$data.point.A) + String(this.$data.point.FC) + String(this.$data.point.AC);
        // eslint-disable-next-line
        console.log( "得点" + point );

        event.target.blur();
        if(this.$data.current < this.$data.questions.length - 1 ){
           this.$data.current += 1;
        }else{
          const answerPattern = this.generatePattern();
          // eslint-disable-next-line
          console.log( "得点レベル" + answerPattern );
          const personalityType = personalityService.getPattern(Number(answerPattern));
          // eslint-disable-next-line
          console.log(  "分類パターン" + personalityType );
          this.navigate(personalityType);
        }
     },
     generatePattern(){
       const pattern = String( ++this.$data.point.CP) + String( ++this.$data.point.NP) + String( ++this.$data.point.A ) + String(++this.$data.point.FC ) + String(++this.$data.point.AC  );
       return pattern;
     },
     reset(){
        this.$data.current = 0;
        this.$data.point = {
          CP: 0,
          NP: 0,
          A: 0,
          FC: 0,
          AC: 0
        }
     },
     navigate(personalityType){
       this.$router.push({ name: "result", params: { type: personalityType } });
     }
  }
};

</script>

<style lang="scss" scoped>
@import "@/assets/css/_var/_variables.scss";
@import "@/assets/css/_mixin/_breakpoints.scss";
@import "@/assets/css/pages/question.scss";

.fade-enter-active{
  transition: opacity 3.5s ease;
}
.fade-leave-active {
  transition: opacity 3.5s ease;
}
.fade-enter,
.fade-leave-to{
  opacity: 0;
}


</style>